import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a401aa4272f6a643499ac5bb980dd2162b from "./generated-9c359237-abc3-4221-9c9a-394ac6b2bd4b.json";

import a0e7aa252c4a87a65de35f2a9c70a3d06b from "./generated-96f31a70-45d3-4903-b33e-95d4639d7041.json";

import af11a2db3a13ef43086e5573078fa7077b from "./generated-3beec7ab-b4a3-41f2-92e8-6c9dade7b447.json";

import ac01c67fb1ae4adb21419800c1941725ab from "./generated-87aa9c98-2582-41c2-bcc5-f3cf2f1033b9.json";

import a75d99fccdb9b59924a57a2967412b177b from "./generated-e926210b-7004-45c7-a7b8-5fceee718f9b.json";

import afa789700b0a502c0b6305a973acc9131b from "./generated-d8b730e4-6968-4272-ad86-253d3ad5a8ee.json";

import aaabaf1467ffc6cb7db92893e9dc1c277b from "./generated-a2ed4342-e818-483d-ac7b-c6f65730c174.json";

import a60802732d478da4f1eb33c150694faa1b from "./generated-409d712d-1304-4d20-9e71-349ea1aa7fb2.json";

import a09f4cb16b767d2ef814c483182d1dafdb from "./generated-10ded7ea-c45a-4a90-9384-d981df0326b3.json";

import a60c2e4472e935042f2d5ad0588eb40cdb from "./generated-759bbb0c-0d71-4413-8f07-7e7cfc380dfa.json";

import a2c0ed54a2fce15857b3c9204dc2df616b from "./generated-d4eed76d-ce4d-4b50-b5e6-3cfbe4091973.json";

import a677d29a72fcdf9c60421af4d31053e3cb from "./generated-c9ec70f3-d68e-4027-9b87-bd18418469ba.json";

import a1fc34508270936ecf96c754655ae45c7b from "./generated-873c89be-7746-46b2-8d3c-677ffcdf03d9.json";

import ab6bb860bb9d97cfa2dbb943f7e198b14b from "./generated-d33bc3ec-bd73-44ed-90b9-e40899938a1c.json";

import a9a5908222cad532d0fb6d15fd6b60e98b from "./generated-474d12d6-07fd-4611-b882-0e005189ac5b.json";

import ac6d1624d09b9c537d3fbcf80ca8fb594b from "./generated-bde74cff-d626-420c-a0ea-2f16c3ddf260.json";

import ab28c6df76632da1f552351d850b1898cb from "./generated-a978648e-eeaf-4481-8cce-50c483cb155f.json";

import a85603c5ebe8922d91ff676d46c525dc6b from "./generated-8e92d678-e35d-45fb-815c-9d233748a6be.json";

import aef0bc3b19d954ae90e3cd21b9caec152b from "./generated-bcc53506-51f1-4144-bbe4-ec3fec760084.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a401aa4272f6a643499ac5bb980dd2162b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a0e7aa252c4a87a65de35f2a9c70a3d06b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af11a2db3a13ef43086e5573078fa7077b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ac01c67fb1ae4adb21419800c1941725ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a75d99fccdb9b59924a57a2967412b177b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(afa789700b0a502c0b6305a973acc9131b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aaabaf1467ffc6cb7db92893e9dc1c277b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a60802732d478da4f1eb33c150694faa1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a09f4cb16b767d2ef814c483182d1dafdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a60c2e4472e935042f2d5ad0588eb40cdb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a2c0ed54a2fce15857b3c9204dc2df616b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a677d29a72fcdf9c60421af4d31053e3cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a1fc34508270936ecf96c754655ae45c7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab6bb860bb9d97cfa2dbb943f7e198b14b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a9a5908222cad532d0fb6d15fd6b60e98b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac6d1624d09b9c537d3fbcf80ca8fb594b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ab28c6df76632da1f552351d850b1898cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a85603c5ebe8922d91ff676d46c525dc6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aef0bc3b19d954ae90e3cd21b9caec152b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ab28c6df76632da1f552351d850b1898cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */